// src/components/Dropdown.js

const Dropdown = ({
  items,
  label,
  setSelectedValue,
  setModalIsOpen,
  isHeader,
  isModalOpen,
  type,
}) => {
  // Handle change in selection
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const openModal = () => setModalIsOpen(true);

  return (
    <div className="flex items-center justify-between space-x-4">
      {type === "no-label" ? (
        <></>
      ) : (
        <div
          htmlFor="dropdown"
          className={`block ${
            isHeader && "w-1/2"
          } text-md font-medium text-white-300 `}
        >
          {label === "Provider/Template:" && !isModalOpen ? (
            <div className="underline cursor-pointer" onClick={openModal}>
              {label}
            </div>
          ) : (
            label
          )}
        </div>
      )}
      <select
        id="dropdown"
        onChange={handleChange}
        className={`block ${
          !isHeader && "w-1/2"
        } px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
      >
        {items.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
